module.exports = __webpack_public_path__ + "img/BlinkArt_Spear1H_Epic2.a990d8b5.png";